import React, { useEffect } from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";

const KontentItemFundraisingBoxEmbed = ({ data }) => {
  const fundraisingBox = data.value ? data.value[0] : data;

  if (!fundraisingBox || !fundraisingBox.elements) {
    return null;
  }

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://secure.fundraisingbox.com/app/widgetJS?cfh=${fundraisingBox.elements.id.value}`;
    script.type = "text/javascript";
    script.async = true;

    document.body.appendChild(script);

    return () => document.body.removeChild(script);
  }, []);

  return (
    <div className="text-section__fullwidth fundraising-box">
      <div id="fbIframeDiv" />
      <a target="_blank" href="https://www.fundraisingbox.com" rel="noreferrer">
        <img src="https://secure.fundraisingbox.com/images/FundraisingBox-Logo-Widget.png" alt="FundraisingBox Logo" />
      </a>
    </div>
  );
};

export const query = graphql`
  fragment KontentItemFundraisingBoxEmbed on kontent_item_fundraising_box_embed {
    id
    system {
      codename
    }
    elements {
      id {
        value
      }
    }
  } 
`;

KontentItemFundraisingBoxEmbed.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemFundraisingBoxEmbed;
